import * as React from 'react';
import * as styles from './DesktopContentLayout.css';
import { Section } from '../../Section';

export interface IDesktopContentLayoutProps {
  gallery: React.ReactNode;
  newbuildingInfo: React.ReactNode;
  myHomeTrap: React.ReactNode;
  loadMoreButton: React.ReactNode;
}

export const DesktopContentLayout: React.FC<IDesktopContentLayoutProps> = props => {
  const { gallery, newbuildingInfo, myHomeTrap, loadMoreButton } = props;

  return (
    <div className={styles['container']} data-testid="DesktopContentLayout">
      <Section className={styles['newbuildingInfo']} data-mark="jk_info_construction_progress">
        {newbuildingInfo}
      </Section>

      {myHomeTrap}

      <Section className={styles['gallery']} data-mark="gallery_construction_progress">
        {gallery}
        {loadMoreButton}
      </Section>
    </div>
  );
};
